require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 642
// module chunks = 0